/**
 * Angrefristen, og skjemaet som hører til.
 *
 * Fristen er speiling av `apps/api/src/shared/angrerett.ts`, som er den
 * ordrebekreftelsen regner med og der begrunnelsen står.
 *
 * Selve skjemaet er en side: `/vilkaar/angrerett`. Teksten som sendes, bygges
 * på serveren av det kunden fylte ut – se `apps/api/src/shared/angrerett.ts`.
 * Her ligger bare fristen, som sida og ordrebekreftelsen må være enige om.
 */

/** Dager, regnet fra dagen etter avtaleinngåelsen. */
export const ANGREFRIST_DAGER = 14;

/** Siste dagen kunden kan gå fra kjøpet. Hele den dagen. */
export function angrefrist(avtaledato: Date): Date {
  const frist = new Date(avtaledato);
  frist.setDate(frist.getDate() + ANGREFRIST_DAGER);
  return frist;
}

/** Om fristen fortsatt løper. */
export function innenforAngrefristen(avtaledato: Date, naa = new Date()): boolean {
  const frist = angrefrist(avtaledato);
  frist.setHours(23, 59, 59, 999);
  return naa <= frist;
}

/** Hvor skjemaet ligger. Speiling av API-ets `ANGRERETT_STI`. */
export const ANGRERETT_STI = '/vilkaar/angrerett';
